import React, { Component } from 'react';
import { connect } from 'react-redux';

// Layouts
import NavBar from '../layout/NavBar';
import loginCheck from '../login/LoginCheck';
import DoctorPoolManagerBody from './DoctorPoolManagerBody';

class DoctorPoolManagerComponent extends Component {
  render() {
    return (
      <React.Fragment>
        <NavBar />
        <DoctorPoolManagerBody />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  offlineConsult: state.offlineConsult,
});

export default connect(mapStateToProps)(loginCheck(DoctorPoolManagerComponent));
